import { ColumnType } from '@/pages/mana/components/Table';
import {Divider, Popover, TreeDataNode} from 'antd';
import {courseRecord, getCourseByGrade} from '@/utils/const';

const SchoolGradeRecord: Record<string, string> = {
  'P': '小学',
  'J': '初中',
  'S': '高中'
};

export function getFileFormat (data: PermissionTree[]){
  let currentTree:TreeDataNode[] = [];
  data.forEach((el, i) => {
    currentTree.push({
      title: el.label,
      key: el.code,
      children: el.children.map((dl, index: number) => {
        return {
          title: dl.label,
          key: dl.code,
          className: index === 0 ? 'tree-leaf__inline tree-leaf-first' : 'tree-leaf__inline'
        };
      })
    });
  });
  return currentTree;
}

export function setSchoolGradeTreeData () {
  let currentTree:TreeDataNode[] = [];
  const grade = ['P', 'J', 'S'];
  grade.forEach((el) => {
    const course = ['WHOLE_COURSE_T', ...getCourseByGrade(el)];
    currentTree.push({
      title: SchoolGradeRecord[el],
      key: el + '-' + 'WHOLE',
      children: course.map((dl, index: number) => {
        return {
          title: dl === 'WHOLE_COURSE_T' ? '全科' : courseRecord[dl],
          key: el + '-' + dl,
          className: index === 0 || index === 10 ? 'tree-leaf-grade tree-leaf-first' : 'tree-leaf-grade',
          blockNode: true
        };
      })
    });
  });
  return currentTree;
}

export const getColumns = (
  personFn: TableCallBack<RoleMana>,
  editFn: TableCallBack<RoleMana>,
  deleteFn: TableCallBack<RoleMana>
) => {
  const columns: ColumnType<RoleMana>[] = [
    {
      title: '角色',
      dataIndex: 'name',
      key: 'name',
      width: 160
    },
    {
      title: '查看模块',
      dataIndex: 'permissionLabels',
      key: 'permissionLabels',
      width: 260,
      ellipsis: true
    },
    {
      title: '查看分析范围',
      key: 'dataScope',
      width: 260,
      ellipsis: true,
      render: (_, p) => p.dataScope.map(el => `${SchoolGradeRecord[el.schoolgradeDcode]}学段，${el.allCourse ? '所有科目' : '权限科目'}`).join('；')
    },
    {
      title: '人员',
      key: 'unames',
      width: 180,
      render: (_, p) => p.unames.length <= 3 ? p.unames.join('、') :
        <span>
          <Popover content={p.unames.join('、')} trigger="hover">
            <a>{p.unames.length}</a>
          </Popover>
          <span style={{color: '#909399', marginLeft: '10px'}}>(上移显示)</span>
        </span>
    },
    {
      title: '操作',
      key: 'action',
      width: 180,
      render (_, p) {
        return <>
          <a onClick={() => personFn(p)}>人员清单</a>
          <Divider type="vertical"/>
          <a onClick={() => editFn(p)}>修改</a>
          <Divider type="vertical"/>
          <a onClick={() => deleteFn(p)}>删除</a>
        </>;
      }
    }
  ];
  return columns;
};
